export const GET_EXCLUSIVITY_BANNER = ' GET_EXCLUSIVITY_BANNER';
